export default "__VITE_ASSET__49e5297d__"